import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requireSession } from '@/app/guards';
import { NotFoundView, RouteErrorView } from '@/features/shell';

/**
 * Print documents (A5 printable application): signed-in like every app page, but rendered without the app shell
 * (no sidebar or header) so the document prints cleanly on A4.
 */
export const Route = createFileRoute('/_print')({
  beforeLoad: async ({ context, location }) => {
    await requireSession(context.queryClient, location.href);
  },
  component: Outlet,
  errorComponent: ({ error, reset }) => (
    <div className="mx-auto max-w-form p-6">
      <RouteErrorView error={error} reset={reset} />
    </div>
  ),
  notFoundComponent: () => <NotFoundView />,
});
